module.exports = __webpack_public_path__ + "static/img/1029_big.102fe60.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1029_big.png
// module id = GLm/
// module chunks = 1